import React, { useState } from "react";
import Navbar from "../components/sub-comp/Navbar";
import Footer from "../components/sub-comp/MainFooter";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const VideoGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedVideo, setSelectedVideo] = useState(null);

  const categories = [
    { id: "all", name: "All Videos" },
    { id: "tutorials", name: "Tutorials" },
    { id: "events", name: "Events" },
    { id: "campus", name: "Campus Life" },
    { id: "interviews", name: "Interviews" },
  ];

  const videos = [
    {
      id: 1,
      thumbnail: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80",
      title: "Introduction to Computer Programming",
      description: "Learn the basics of programming with our expert instructors",
      category: "tutorials",
      duration: "15:32",
      views: "2.4K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Dr. Sarah Johnson"
    },
    {
      id: 2,
      thumbnail: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
      title: "Graduation Ceremony 2024",
      description: "Celebrating the achievements of our graduating class",
      category: "events",
      duration: "45:18",
      views: "5.1K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "JRIIT Events Team"
    },
    {
      id: 3,
      thumbnail: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=800&q=80",
      title: "Campus Tour - Virtual Walkthrough",
      description: "Explore our modern facilities and beautiful campus grounds",
      category: "campus",
      duration: "12:45",
      views: "3.2K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Student Ambassadors"
    },
    {
      id: 4,
      thumbnail: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80",
      title: "Engineering Workshop Safety Guidelines",
      description: "Essential safety protocols for hands-on engineering work",
      category: "tutorials",
      duration: "8:56",
      views: "1.8K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Prof. Michael Chen"
    },
    {
      id: 5,
      thumbnail: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=800&q=80",
      title: "Student Success Stories",
      description: "Hear from our alumni about their career journeys",
      category: "interviews",
      duration: "22:14",
      views: "4.7K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Alumni Network"
    },
    {
      id: 6,
      thumbnail: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80",
      title: "Business Case Study Analysis",
      description: "Real-world business scenarios and problem-solving approaches",
      category: "tutorials",
      duration: "18:33",
      views: "2.9K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Dr. Emily Rodriguez"
    },
    {
      id: 7,
      thumbnail: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=80",
      title: "Accounting Software Tutorial",
      description: "Master popular accounting software tools and applications",
      category: "tutorials",
      duration: "25:47",
      views: "3.6K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Prof. David Thompson"
    },
    {
      id: 8,
      thumbnail: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80",
      title: "Tourism Industry Insights",
      description: "Current trends and opportunities in the tourism sector",
      category: "tutorials",
      duration: "16:22",
      views: "2.1K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Dr. Lisa Wang"
    },
    {
      id: 9,
      thumbnail: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
      title: "Short Course Showcase",
      description: "Overview of our specialized short course offerings",
      category: "campus",
      duration: "11:38",
      views: "1.5K",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      instructor: "Course Coordinators"
    }
  ];

  const filteredVideos = selectedCategory === "all" 
    ? videos 
    : videos.filter(video => video.category === selectedCategory);

  const openVideoModal = (video) => {
    setSelectedVideo(video);
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-custom-pink to-purple-800 text-white">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Video <span className="text-gold">Gallery</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
            Watch educational content, campus events, and student success stories
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-8 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-2 md:gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                  selectedCategory === category.id
                    ? "bg-custom-pink text-white shadow-lg transform scale-105"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-custom-pink"
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Video Grid */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredVideos.map((video) => (
              <div
                key={video.id}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
                onClick={() => openVideoModal(video)}
              >
                {/* Thumbnail Container */}
                <div className="relative group">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  
                  {/* Play Button Overlay */}
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                      <svg className="w-10 h-10 text-custom-pink ml-1" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                  </div>

                  {/* Duration Badge */}
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-1 bg-black/70 text-white text-xs font-medium rounded">
                      {video.duration}
                    </span>
                  </div>

                  {/* Category Badge */}
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 bg-gold text-white text-xs font-medium rounded-full">
                      {categories.find(cat => cat.id === video.category)?.name}
                    </span>
                  </div>
                </div>

                {/* Video Info */}
                <div className="p-4">
                  <h3 className="font-bold text-lg text-gray-800 mb-2 line-clamp-2 group-hover:text-custom-pink transition-colors duration-300">
                    {video.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                    {video.description}
                  </p>
                  
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <span className="flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      {video.views}
                    </span>
                    <span className="text-xs">{video.instructor}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* No Videos Message */}
          {filteredVideos.length === 0 && (
            <div className="text-center py-20">
              <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">No videos found</h3>
              <p className="text-gray-500">Try selecting a different category or check back later for new content.</p>
            </div>
          )}
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-custom-pink to-purple-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Have a Great Video to Share?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Submit your educational videos and help others learn from your expertise!
          </p>
          <button className="bg-gold text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-yellow-500 transition-colors duration-300 transform hover:scale-105">
            Submit Video
          </button>
        </div>
      </section>

      {/* Video Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
            <div className="p-4 border-b flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-800">{selectedVideo.title}</h3>
              <button
                onClick={closeVideoModal}
                className="text-gray-500 hover:text-gray-700 transition-colors duration-300"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-4">
              <div className="relative w-full aspect-video mb-4">
                <iframe
                  src={selectedVideo.videoUrl}
                  title={selectedVideo.title}
                  className="w-full h-full rounded-lg"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              
              <div className="space-y-3">
                <h4 className="text-lg font-semibold text-gray-800">{selectedVideo.title}</h4>
                <p className="text-gray-600">{selectedVideo.description}</p>
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <span>Duration: {selectedVideo.duration}</span>
                  <span>Views: {selectedVideo.views}</span>
                  <span>Instructor: {selectedVideo.instructor}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default VideoGallery;
